import {Component, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';

import {CardModule} from 'primeng/card';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {ButtonModule} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {FormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {FormInputTextComponent, UtilsService} from '@shared-lib';
import {PATTERN_EMAIL} from '../../shared/constants/app-constants';
import {RippleModule} from 'primeng/ripple';
import {environment} from '../../../environments/environment';
import {AccountService, StorageService} from '../service';
import {finalize} from 'rxjs';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {RecaptchaComponent, RecaptchaFormsModule, RecaptchaModule} from 'ng-recaptcha-2';
import {Router} from '@angular/router';
import {DialogsUtilsService} from '../service/utils/dialogs-utils.service';
import {ThemeService} from '../theme/theme.service';
import {Divider} from 'primeng/divider';

@Component({
	selector: 'login',
	templateUrl: './login.component.html',
	imports: [
		CardModule,
		ToggleButtonModule,
		ButtonModule,
		FormsModule,
		TranslateModule,
		ReactiveFormsModule,
		RippleModule,
		ProgressSpinnerModule,
		RecaptchaFormsModule,
		RecaptchaModule,
		FormInputTextComponent,
		TooltipModule,
		Divider
	],
	styleUrls: ['./login.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {

	@ViewChild('captchaRef') captchaRef!: RecaptchaComponent;

	signUpFC: FormControl = new FormControl(null, [Validators.required, Validators.pattern(PATTERN_EMAIL)]);
	captchaFC: FormControl = new FormControl(null, [Validators.required]);
	logginIn = false;
	sendingInvite = false;
	autofocusEmail = false;
	appVersion = environment.appVersion;
	captchaSiteKey = environment.captchaKey;

	activeTab: 'login' | 'register' = 'login';

	screenHeight: number;
	headerImgSrc = environment.loginLogoURL;

	isProduction: boolean = environment.production;

	constructor(private accountService: AccountService,
							private translate: TranslateService,
							protected utils: UtilsService,
							private storage: StorageService,
							private router: Router,
							private dialogUtils: DialogsUtilsService,
							private themeService: ThemeService) {
	}

	@HostListener('window:resize')
	getScreenSize() {
		this.screenHeight = window.innerHeight;
	}

	// per gestire l'indietro da browser...
	@HostListener('window:pageshow', ['$event'])
	onPageShow(event: PageTransitionEvent) {
		if (event.persisted) {
			this.logginIn = false;
		}
	}

	ngOnInit() {
		if (this.router.url.includes('login-crm-demo')) {
			this.activeTab = 'register';
		}
		// se la sessione è realmente valida (verifica col BE, non solo lo stato locale) evito di mostrare di nuovo il login
		this.accountService.identity().subscribe(userData => {
			if (userData) {
				this.router.navigate(['applicazioni']);
				return;
			}
			this.initData();
			this.getScreenSize();
			this.logginIn = false;
			this.captchaFC.statusChanges.subscribe(() => (this.captchaFC.valid ? this.signUpFC.enable() : this.signUpFC.disable()));
			this.themeService.applyThemeFromAzienda(); // ri-applichiamo i css di default "Kleros"
		});
	}

	ngOnDestroy() {
		this.logginIn = false;
	}

	togglePannello() {
		this.activeTab = this.activeTab === 'login' ? 'register' : 'login';
		if (this.activeTab === 'register') {
			this.openedRegister();
		}
	}

	openedRegister() {
		this.autofocusEmail = true;
		// refresh del captcha
		try {
			this.captchaRef.reset();
		} catch (e) {
			// console.error('ERRORE REFRESH CAPTCHA', e);
		}
	}

	private initData() {
		this.storage.clearAll();
		this.accountService.authenticate(null); // resetto utente
	}

	loginAzure() {
		this.logginIn = true;
		window.location.href = environment.loginURL;
	}

	register() {
		if (this.captchaFC.valid) {
			this.sendingInvite = true;
			this.accountService.sendInvitation(this.signUpFC.value).pipe(finalize(() => this.sendingInvite = false)).subscribe(() => {
				this.dialogUtils.openAdviseDialog(this.translate.instant('conferma'), this.translate.instant('confermaInvitoRegistrazione'), 'info');
				this.signUpFC.reset();
				this.activeTab = 'login'; // ritorno ad accedi
			});
		}
	}

}
